import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "../../store/state/app.state";
import { NzMessageService } from "ng-zorro-antd/message";
import { GlobalHeaderDataService } from "../global-header-data.service";
import { environment } from "../../../environments/environment";
import { Dictionary } from "src/app/store/models/common_types";
import { CompanyPageMeta } from "src/app/store/models/company-page-store.model";
import { SetRecentCompanies } from "src/app/store/actions/global-header.actions";
import { RecentCompaniesDataResponse } from "src/app/store/models/global-header.model";
import {
  VAIconRegistryService,
  comment,
  close,
  questionCircle,
} from "@va/core-library/icons";
@Component({
  selector: "app-global-primary-header",
  templateUrl: "./global-primary-header.component.html",
  styleUrls: ["./global-primary-header.component.scss"],
})
export class GlobalPrimaryHeaderComponent {
  legacyUrl = `${window.caUrl}/app`;
  imitationBy = "";
  usersnapJsKey = "";
  snapEmail = "";
  userName = "";
  assets = environment.assetUrl;
  showDeprModal = false;
  showDeprDetails = false;
  userId = "";
  enableUsersnap = true;
  isMenuOpen = false;
  recentlyVisitedCompanies = [];

  constructor(
    private store: Store<AppState>,
    private dataService: GlobalHeaderDataService,
    private message: NzMessageService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([close, comment, questionCircle]);
  }

  ngOnInit() {
    this.store
      .select(stateGetter("leftPanel", "enableUsersnap"))
      .subscribe((enableUsersnap: boolean) => {
        this.enableUsersnap = enableUsersnap;
      });
    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.usersnapJsKey = data.usersnapJsKey;
        this.snapEmail = data.userDetails ? data.userDetails.email : "";
        this.userName = data.userName;
        this.userId = data.userId;

        if (
          this.usersnapJsKey &&
          this.usersnapJsKey !== "" &&
          this.enableUsersnap
        ) {
          window.onUsersnapLoad = (api) => {
            api.init({
              button: { isHidden: true },
            });
            api.on("open", (event) => {
              event.api.setValue("custom", {
                email: this.snapEmail,
                username: this.userName,
              });
              event.api.setValue("visitor", this.snapEmail);
            });
            window.Usersnap = api;
          };
          const usn = (
            document.getElementById("pendo-script-tag") || ({} as any)
          ).nonce;
          const script: any = document.createElement("script");
          script.async = 1;
          script.src = `https://widget.usersnap.com/load/${this.usersnapJsKey}?onload=onUsersnapLoad&n=${usn}`;
          if (environment.showZendesk) {
            const zendeskScript: any = document.createElement("script");
            zendeskScript.id = "ze-snippet";
            zendeskScript.nonce =
              "BV0EJ0qH+2CbScIv+W3A+u6bRiEcbko2ti2hG8ixBX82Q2pnJkebYGHSl3x3intJ";
            zendeskScript.src =
              "https://static.zdassets.com/ekr/snippet.js?key=00a68f0c-c1ac-491b-a39a-c6fec9c38f36";
            document.getElementsByTagName("head")[0].appendChild(zendeskScript);

            // Since dynamically adding a nonce value to a zendesk script tag isn't working, add nonce value by updating outerHTML.
            const updatedScriptWithNonceElement =
              '<script id="ze-snippet" nonce="BV0EJ0qH+2CbScIv+W3A+u6bRiEcbko2ti2hG8ixBX82Q2pnJkebYGHSl3x3intJ" src="https://static.zdassets.com/ekr/snippet.js?key=00a68f0c-c1ac-491b-a39a-c6fec9c38f36"></script>';

            const zendeskScriptElement = document.getElementById("ze-snippet");
            if (zendeskScriptElement) {
              zendeskScriptElement.outerHTML = updatedScriptWithNonceElement;
            }
          }

          document.getElementsByTagName("head")[0].appendChild(script);
          // $rootScope.$broadcast('setFooterUserSnap', $scope.usersnap);
        }
        if (this.userId) {
          this.shouldShowIEDeprModal();
        }
      });
    this.store
      .select(stateGetter("globalHeader", "recentCompanies"))
      .subscribe((data: Dictionary<CompanyPageMeta>) => {
        this.updateRecentCompanies(data);
      });
    this.dataService.getImitatedInfo().subscribe(
      (data: any) => {
        this.imitationBy = data.imitation_by;
      },
      (error) => {
        console.error(error);
      },
    );
    this.getRecentCompanies();
  }

  updateRecentCompanies(data) {
    const recentComps = [];
    let tabIndex = 0;
    data.forEach((val) => {
      recentComps.push({
        n: val.n,
        sn: val.sn,
        c: val.c,
        tabIndex: tabIndex,
        url: `/company/${val.sn}`,
      });
      tabIndex++;
    });
    this.recentlyVisitedCompanies = recentComps;
  }

  stopImitation() {
    this.dataService.stopImitation().subscribe(
      () => {
        this.message.success(`Imitation stopped.`, {
          nzDuration: 2000,
        });
        // alert("Imitation stopped.");
        setTimeout(() => {
          window.location.href = `${window.caUrl}/signout`;
        }, 2000);
      },
      (error) => {
        console.error(error);
        this.message.error(`unable stop imitation. ${error.message}`, {
          nzDuration: 2000,
        });
        // alert("unable stop imitation. " + error.message);
      },
    );
  }

  onClickFeedback() {
    if (this.usersnapJsKey && this.usersnapJsKey !== "") {
      window.Usersnap.init({
        button: { isHidden: true },
      });
      window.Usersnap.on("open", (event) => {
        event.api.setValue("custom", {
          email: this.snapEmail,
          username: this.userName,
        });
        event.api.setValue("email", this.snapEmail);
        event.api.setValue("comment", "");
      });
      setTimeout(function () {
        window.Usersnap.open();
      }, 1000);
    }
  }

  shouldShowIEDeprModal() {
    if (!this.userTokenExists()) {
      this.showDeprModal = this.isBrowserIE();
    } else {
      this.showDeprModal = false;
    }
  }

  userTokenExists(): boolean {
    return localStorage[`IEPopupToken_${this.userId}`];
  }

  IEUnderstand() {
    this.showDeprModal = false;
    localStorage[`IEPopupToken_${this.userId}`] = true;
  }

  isBrowserIE() {
    try {
      const sAgent = window.navigator.userAgent;
      const IE10orOlder = sAgent.indexOf("MSIE");
      const IE11 = sAgent.indexOf("Trident/");

      if (IE10orOlder > 0 || IE11 > 0) {
        return true;
      }

      return false;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
  isOpen(isVisible) {
    this.isMenuOpen = isVisible;
  }
  getRecentCompanies() {
    this.dataService
      .getRecentlyVisitedCompanies()
      .subscribe((data: RecentCompaniesDataResponse) => {
        this.store.dispatch(new SetRecentCompanies(data.data));
      });
  }
}
